import css from 'styled-jsx/css';
import { sansSerif } from 'styles/css-constants';

export default css`
  .AmpSpread {
    margin: 1rem auto;
    padding: 0 1rem;
    max-width: 800px;
  }
  .AmpSpread a {
    text-decoration: none;
  }
  .AmpSpread__title {
    padding-bottom: 0.25rem;
    margin-bottom: 1rem;
    border-bottom: 2px solid #000;
    font-family: ${sansSerif};
  }
  .AmpSpread__title h1 {
    margin: 0;
    font-size: 1.2rem;
    text-transform: uppercase;
    letter-spacing: 0.02em;
  }
  .AmpSpread__items {
    display: flex;
    flex-direction: column;
  }
  .AmpSpread__item {
    margin-bottom: 1rem;
  }
  .AmpSpread__item--ad {
    margin: 2rem auto;
  }

  /* AD ORDERING */
  /*
   * set ordering on items to redistribute ad items
   * teaser items 1-4
   */

  .AmpSpread__item--teaser:nth-child(-n + 4) {
    order: 0;
  }

  /* teaser items 5-8 */
  .AmpSpread__item--teaser:nth-child(-n + 8):not(:nth-child(-n + 4)) {
    order: 2;
  }

  /* teaser items 9-12 */
  .AmpSpread__item--teaser:nth-child(-n + 12):not(:nth-child(-n + 8)) {
    order: 4;
  }

  /* teaser items 13-16 */
  .AmpSpread__item--teaser:nth-child(-n + 16):not(:nth-child(-n + 12)) {
    order: 6;
  }

  /* teaser items 17-20 */
  .AmpSpread__item--teaser:nth-child(-n + 20):not(:nth-child(-n + 16)) {
    order: 8;
  }

  /* teaser items 21-24 */
  .AmpSpread__item--teaser:nth-child(-n + 24):not(:nth-child(-n + 20)) {
    order: 10;
  }

  .AmpSpread--4 .AmpSpread__item--ad:nth-last-child(2),
  .AmpSpread--5 .AmpSpread__item--ad:nth-last-child(2),
  .AmpSpread--6 .AmpSpread__item--ad:nth-last-child(2),
  .AmpSpread--7 .AmpSpread__item--ad:nth-last-child(2) {
    order: 1;
  }

  .AmpSpread--8 .AmpSpread__item--ad:nth-last-child(2),
  .AmpSpread--9 .AmpSpread__item--ad:nth-last-child(2),
  .AmpSpread--10 .AmpSpread__item--ad:nth-last-child(2),
  .AmpSpread--11 .AmpSpread__item--ad:nth-last-child(2) {
    order: 3;
  }

  .AmpSpread--8 .AmpSpread__item--ad:nth-last-child(3),
  .AmpSpread--9 .AmpSpread__item--ad:nth-last-child(3),
  .AmpSpread--10 .AmpSpread__item--ad:nth-last-child(3),
  .AmpSpread--11 .AmpSpread__item--ad:nth-last-child(3) {
    order: 1;
  }

  .AmpSpread--12 .AmpSpread__item--ad:nth-last-child(2) {
    order: 5;
  }

  .AmpSpread--12 .AmpSpread__item--ad:nth-last-child(3) {
    order: 3;
  }

  .AmpSpread--12 .AmpSpread__item--ad:nth-last-child(4) {
    order: 1;
  }

  .AmpSpread--24 .AmpSpread__item--ad:nth-last-child(2) {
    order: 11;
  }

  .AmpSpread--24 .AmpSpread__item--ad:nth-last-child(3) {
    order: 9;
  }

  .AmpSpread--24 .AmpSpread__item--ad:nth-last-child(4) {
    order: 7;
  }

  .AmpSpread--24 .AmpSpread__item--ad:nth-last-child(5) {
    order: 5;
  }

  .AmpSpread--24 .AmpSpread__item--ad:nth-last-child(6) {
    order: 3;
  }

  .AmpSpread--24 .AmpSpread__item--ad:nth-last-child(7) {
    order: 1;
  }
`;
